import { createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../../../assets/images/premium-lock.png'


const _hoisted_1 = {
  class: "navbar navbar-expand-lg px-1 px-md-3 py-0",
  ref: "levelTwoContainer",
  id: "Level_Two_Navbar"
}
const _hoisted_2 = {
  class: "navbar-collapse planner_level w-100 d-flex justify-content-between",
  id: "Level_Two_Menu"
}
const _hoisted_3 = { class: "navigator d-flex align-items-center gap-2 gap-md-4" }
const _hoisted_4 = { class: "d-md-none" }
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "navs d-flex align-items-center" }
const _hoisted_7 = { class: "d-flex" }
const _hoisted_8 = { class: "d-flex" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "d-flex phone-pills-padding px-1"
}
const _hoisted_11 = {
  key: 0,
  class: "d-flex me-1 premium-margin"
}
const _hoisted_12 = {
  class: "ms-1 mb-1 premium-lock-img",
  src: _imports_0
}
const _hoisted_13 = {
  key: 1,
  class: "d-flex"
}
const _hoisted_14 = {
  key: 0,
  class: "me-2"
}
const _hoisted_15 = { class: "px-2 strip-item dropdown app-menu" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-toggle btn p-0 font-size-sm",
  href: "javascript:void(0);",
  id: "User_Dropdown",
  role: "button",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-list-ul fa-lg" }),
  /*#__PURE__*/_createCommentVNode(" <i class=\"fas fa-caret-down ms-1\"></i> ")
], -1 /* HOISTED */)
const _hoisted_17 = {
  class: "dropdown-menu dropdown-menu-end mt-0",
  "aria-labelledby": "User_Dropdown"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "icon fa fa-search blue-text" }, null, -1 /* HOISTED */)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "text-center ps-1 blue-text" }, "Employees", -1 /* HOISTED */)
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* HOISTED */)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "icon fa fa-search blue-text" }, null, -1 /* HOISTED */)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "text-center ps-1 blue-text" }, "Patients", -1 /* HOISTED */)
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<div class=\"dropdown-divider\"></div><li><a class=\"dropdown-item\" href=\"https://community.axxessweb.com/\" target=\"_blank\"><i class=\"fas fa-users icon pe-1 blue-text\"></i><span class=\"text-center blue-text\">User Community</span></a></li><div class=\"dropdown-divider\"></div>", 3)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-key icon pe-1 blue-text" }, null, -1 /* HOISTED */)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "text-center blue-text" }, "Support Key", -1 /* HOISTED */)
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TabsAnimatedHeader = _resolveComponent("TabsAnimatedHeader")!
  const _component_UserProfileManagement = _resolveComponent("UserProfileManagement")!
  const _component_MessagesPreview = _resolveComponent("MessagesPreview")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" DO NOT switch show.bind to if.bind. navItem will not work if if.bind is used "),
    _createElementVNode("nav", _hoisted_1, [
      _createCommentVNode(" Small screen - burger icon menu "),
      _createCommentVNode(" App Menu"),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("a", {
              class: "",
              role: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleAsideNav()))
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(["fas", _ctx.openAgencyNav ? 'fa-angle-double-left' : 'fa-angle-double-right']),
                title: _ctx.openAgencyNav ? 'Open side nav' : 'Close side nav'
              }, null, 10 /* CLASS, PROPS */, _hoisted_5)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createCommentVNode(" Left Nav "),
            _createVNode(_component_TabsAnimatedHeader, {
              activeItem: _ctx.getActiveItem,
              "is-gradient-underline": _ctx.isPathMessaging,
              "recalculate-dimensions": _ctx.connectPermissionLoaded
            }, {
              default: _withCtx(() => [
                _createElementVNode("ul", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.router, (route) => {
                    return _withDirectives((_openBlock(), _createElementBlock("li", {
                      key: route.meta.navItem,
                      class: _normalizeClass(`cursor-pointer ${route.meta.menuName === 'Axxess Connect' ? 'me-2' : 'me-2 me-md-4'} ${_ctx.isActivePath(route.path) ? 'active' : ''}`)
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("button", {
                          class: "link-btn nav-link menu-link",
                          onClick: ($event: any) => (_ctx.goTo(route.path)),
                          ref_for: true,
                          ref: (el) => _ctx.addItemRefs(el, route)
                        }, [
                          _createElementVNode("h6", {
                            class: _normalizeClass(`${_ctx.isActivePath(route.path) ? 'active' : ''} ${route.meta.menuName === 'Axxess Connect' ? 'd-flex align-items-center' : ''}`)
                          }, [
                            _createElementVNode("span", {
                              class: _normalizeClass(`${_ctx.isActivePath(route.path) && route.meta.menuName === 'Axxess Connect' ? 'active gradient-nav-text' : ''} nav-text`)
                            }, _toDisplayString(route.meta.menuName), 3 /* TEXT, CLASS */)
                          ], 2 /* CLASS */)
                        ], 8 /* PROPS */, _hoisted_9),
                        (route.meta.menuName === 'Axxess Connect')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              (!_ctx.isOnlyFamilyPortal && !_ctx.isConnectEnabled)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                    _withDirectives(_createElementVNode("img", _hoisted_12, null, 512 /* NEED_PATCH */), [
                                      [_directive_tooltip, {
                                                    title: _ctx.connectLockMessage,
                                                    placement: 'top',
                                                    className: 'lock-premium'
                                                }]
                                    ])
                                  ]))
                                : _createCommentVNode("v-if", true)
                            ]))
                          : _createCommentVNode("v-if", true)
                      ])
                    ], 2 /* CLASS */)), [
                      [_vShow, _ctx.showRoute(route.meta.navItem)]
                    ])
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["activeItem", "is-gradient-underline", "recalculate-dimensions"])
          ])
        ]),
        _createElementVNode("div", null, [
          (_ctx.showIcons && _ctx.showUserStatus)
            ? (_openBlock(), _createBlock(_component_UserProfileManagement, { key: 0 }))
            : (_ctx.showIcons)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                  (_ctx.isConnectEnabled)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                        _createVNode(_component_MessagesPreview, { "is-axxess-planner-header": _ctx.isAxxessPlannerHeader }, null, 8 /* PROPS */, ["is-axxess-planner-header"])
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("li", null, [
                    _createElementVNode("span", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("div", _hoisted_17, [
                        (_ctx.showEmployeeSearch)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: _normalizeClass(["dropdown-item", _ctx.showEmployees ? 'selected' : '']),
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleEmployeesMenus()))
                            }, _hoisted_20, 2 /* CLASS */))
                          : _createCommentVNode("v-if", true),
                        _hoisted_21,
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: _normalizeClass(["dropdown-item", _ctx.showPatients ? 'selected' : '']),
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.togglePatientsMenu()))
                          }, _hoisted_24, 2 /* CLASS */)
                        ]),
                        _hoisted_25,
                        _createElementVNode("li", null, [
                          (_ctx.liveLoginData)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                class: "dropdown-item",
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.displayLiveLoginToken()))
                              }, _hoisted_30))
                            : _createCommentVNode("v-if", true)
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("v-if", true)
        ])
      ])
    ], 512 /* NEED_PATCH */)
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}